/*
 * File: Team.tsx
 * Project: a-a
 * File Created: Wednesday, 6th November 2024 9:36:16 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 2:26:16 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomHeadline from '../../../components/shared/CustomHeadline/CustomHeadline';
import CustomTab from '../../../components/shared/CustomTab/CustomTab';
import CustomSearch from '../../../components/shared/CustomSearch/CustomSearch';
import zeplinColor from '../../../theme/Color';
import CustomLoader from '../../../components/shared/CustomLoader/CustomLoader';
import { DashboardService } from '../../../service/dashboard.service';
import ClientColumnGrid from '../../../components/featured/Client/ClientColumnGrid';
import ClientsList from '../../../components/featured/Client/ClientsList';
import { ClientService } from '../../../service/client.service';
import TeamsList from '../../../components/featured/Team/TeamsList';
import { TeamService } from '../../../service/team.service';
import styles from './Team.module.css';
type SportsProps = {
  link: '';
  title: '';
  source: '';
};
type TeamData = {
  members: [
    {
      id: string | null;
      position: string | null;
      name: string | null;
      mobile: string | null;
      phone: string | null;
      address: {
        city: string | null;
        country: string | null;
        geocodeAccuracy: string | null;
        latitude: string | null;
        longitude: string | null;
        postalCode: string | null;
        state: string | null;
        street: string | null;
      };
      company: string | null;
      email: string | null;
      openDeals: string | null;
      openTasks: string | null;
      title: string | null;
      profile_image_url: string | null;
    },
  ];
};
const Team = () => {
  // const [loading, setLoading] = useState(false);
  const [layout, setLayout] = useState<'column' | 'row'>('column');
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [data, setData] = useState<TeamData>({
    members: [
      {
        id: '',
        position: '',
        name: '',
        mobile: '',
        phone: '',
        address: {
          city: '',
          country: '',
          geocodeAccuracy: '',
          latitude: '',
          longitude: '',
          postalCode: '',
          state: '',
          street: '',
        },
        company: '',
        email: '',
        openDeals: '',
        openTasks: '',
        title: '',
        profile_image_url: '',
      },
    ],
  });
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const getAllTeam = async () => {
    setLoading(true);
    try {
      const res: TeamData = await TeamService.getAllMembers();
      console.log(res);
      setData(res);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllTeam();
    // sessionStorage.setItem('currentTab', '0');
  }, []);

  const TeamTabs = [
    {
      label: 'Members',
      id: 1,
      isHidden: false,
      Component: (
        <Box>
          <TeamsList layout={layout} category={'all'} loading={loading} data={data} />
        </Box>
      ),
    },
    // {
    //   label: 'Talent',
    //   id: 2,
    //   isHidden: false,
    //   Component: (
    //     <Box>
    //       <TeamsList layout={layout} category={'Talent'} loading={loading} data={data} />
    //     </Box>
    //   ),
    // },
    // {
    //   label: 'Athlete',
    //   id: 3,
    //   isHidden: false,
    //   Component: (
    //     <Box>
    //       <TeamsList layout={layout} category={'Athlete'} loading={loading} data={data} />
    //     </Box>
    //   ),
    // },
    // {
    //   label: 'Business',
    //   id: 4,
    //   isHidden: false,
    //   Component: (
    //     <Box>
    //       <TeamsList layout={layout} category={'Business'} loading={loading} data={data} />
    //     </Box>
    //   ),
    // },
    // {
    //   label: 'Business Development',
    //   id: 5,
    //   isHidden: false,
    //   Component: (
    //     <Box>
    //       <TeamsList
    //         layout={layout}
    //         category={'Business_Development'}
    //         loading={loading}
    //         data={data}
    //       />
    //     </Box>
    //   ),
    // },
  ];
  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);
  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();
      console.log(res);
      setSportsData(res?.latestNews);
    } catch (err) {
      console.log(err, 'err');
    }
  };
  React.useEffect(() => {
    getSportNews();
  }, []);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {' '}
      <Box>
        <CustomHeadline sportsData={sportsData} />
      </Box>
      <Box
        sx={{
          padding: '2rem 1.5rem 0rem 1.5rem',
          // height: '75vh',
          // display: 'flex',
          // flexDirection: 'column',
          // flex: 1,
          position: 'relative',
        }}
      >
        {' '}
        <CustomTab tabs={TeamTabs} handleChange={handleChange} value={value} />
        <Box
          sx={{ position: 'absolute', top: '2rem', right: '1.5rem', display: 'flex', gap: '16px' }}
        >
          {/* <CustomSearch /> */}
          {/* <Box
            sx={{
              borderRadius: '100px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '10px',
              width: '48px',
              height: '48px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            <img src={`/assets/sort-icon.svg`} width='20px' height='20px' />
          </Box> */}
          <Box
            sx={{
              borderRadius: '50px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '6px',
              width: { xs: '82px', xl: '92px' },
              height: { xs: '40px', xl: '48px' },
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
              position: 'relative', // Important for absolute positioning of slider
            }}
          >
            {/* Animated slider background */}
            <Box
              sx={{
                position: 'absolute',
                width: { xs: '35px', xl: '40px' },
                height: { xs: '28px', xl: '36px' },
                backgroundColor: zeplinColor.Brand1,
                opacity: 0.1,
                borderRadius: '40px',
                transition: 'transform 0.3s ease',
                transform:
                  layout === 'column'
                    ? 'translateX(0)'
                    : { xs: 'translateX(35px)', xl: 'translateX(40px)' },
                left: '6px',
              }}
            />

            {/* Column icon */}
            <Box
              onClick={() => setLayout('column')}
              sx={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              <img
                src={
                  layout === 'column'
                    ? `/assets/selected-col-layout.svg`
                    : `/assets/column-layout-icon.svg`
                }
                className={layout === 'column' ? styles['icons'] : styles['selected-icons']}
                alt='Column layout'
                style={{
                  transition: 'all 0.2s ease',
                  transform: layout === 'column' ? 'scale(1.1)' : 'scale(1)',
                }}
              />
            </Box>

            {/* Row icon */}
            <Box
              onClick={() => setLayout('row')}
              sx={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              <img
                src={
                  layout === 'row'
                    ? `/assets/selected-row-layout.svg`
                    : `/assets/row-layout-icon.svg`
                }
                className={layout === 'row' ? styles['icons'] : styles['selected-icons']}
                alt='Row layout'
                style={{
                  transition: 'all 0.2s ease',
                  transform: layout === 'row' ? 'scale(1.1)' : 'scale(1)',
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {/* {loading ? (
        <CustomLoader
          open={loading}
          handleCloseModal={() => {
            setLoading(false);
          }}
        />
      ) : (
        ''
      )} */}
    </Box>
  );
};

export default Team;
